<template lang="pug">
.basketItem
  .row
    .serviceLogo(:style="logoStyles")
    .serviceName {{ item.service.name }}
    .name {{ item.name }}
    template(v-if="item.newPrice")
      .price
        .actual {{ item.newPrice }} ₽
        .old {{ item.price }} ₽
    template(v-else)
      .price {{ item.price }} ₽
    ui-svg-icon.delete(
      name="delete"
      :size="24"
      :originalColors="true"
      @click="onRemoveButtonClick"
    )
</template>

<script>
import { computed, inject } from 'vue'
import BasketItem from '../models/BasketItem'
export default {
  props: {
    item: {
      type: BasketItem,
      default: null
    }
  },
  setup (props) {
    const store = inject('store')
    const logoStyles = computed(() => {
      return { backgroundImage: `url('${props.item.service.cover}')` }
    })
    const onRemoveButtonClick = () => store.basket.removeProduct(props.item.nomenklatura)
    return { onRemoveButtonClick, logoStyles }
  }
}
</script>

<style lang="sass">
.basketItem
  padding: 7*$u 6*$u
  border-radius: 10px
  background-color: $cWhite
  @media (max-width: $XLWidth)
    padding: 4*$u
  .row
    display: flex
    align-items: center
    grid-template-areas: "serviceLogo serviceName delete" "serviceLogo name ." ". price ."
    grid-template-columns: 40px 1fr 24px
    gap: 0 4*$u
    justify-content: flex-start
    &.specialItem
      color: $lectaBlue
    @media (max-width: $XLWidth)
      display: grid
    &.bot
      display: flex
      justify-content: space-between
      border-top: 1px solid $lectaGrey
      padding-top: 7.5*$u
      margin-top: 6*$u
      @media (max-width: $XLWidth)
        flex-direction: column
        align-items: flex-end
        &.specialItem
          display: grid
          color: $lectaBlue
      > .text
        font-family: GolosTextWebRegular
        font-weight: bold
        font-size: 14px
        color: $lectaBlue
        max-width: 390px
        line-height: 17px
        @media (max-width: $XLWidth)
          max-width: 100%
          margin-bottom: 4*$u
  .serviceLogo
    grid-area: serviceLogo
  .serviceName
    white-space: nowrap
    flex-shrink: 0
    grid-area: serviceName
    font-family: GolosTextWebBold
    font-size: 18px
    width: 110px
  .name
    font-family: GolosTextWebRegular, serif
    font-size: 18px
    grid-area: name
    margin: 0 auto 0 30*$u
    @media (max-width: $XXXLWidth)
      margin: 0 auto 0 13*$u
    @media (max-width: $XLWidth)
      margin: 0
  .delete
    margin-left: 17.5*$u
    grid-area: delete
    cursor: pointer
    flex-shrink: 0
    @media (max-width: $XLWidth)
      margin: 0
  .price
    margin-left: auto
    grid-area: price
    width: 16*$u
    display: flex
    flex-direction: column
    text-align: right
    white-space: nowrap
    @include font('t16-demibold')
    @media (max-width: $XLWidth)
      margin: 3*$u 0 0 0
      flex-direction: row
      align-items: center
      .old
        margin-left: 2*$u
        font-family: GolosTextWebMedium
        font-size: 3.5*$u
        line-height: 24px
    .actual
      @include font('t16-demibold')
      line-height: 20px
      color: $lectaBlue
    .old
      font-family: GolosTextWebMedium
      font-size: 3.5*$u
      line-height: 24px
      text-decoration: line-through
      color: $cDarkGrey
</style>
